<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="110px"
            size="mini"
          >
            <el-form-item
              label="参与时间"
              prop="updatedTime"
            >
              <q-date-picker v-model="searchForm" ref="dateRef" />
            </el-form-item>
            <el-form-item label="区域" prop="orgName">
              <el-input
                v-model="searchForm.orgName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="经销商" prop="cusName">
              <el-input
                v-model="searchForm.cusName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="门店" prop="storeName">
              <el-input
                v-model="searchForm.storeName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="职员" prop="staffName">
              <el-input
                v-model="searchForm.staffName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="顾客姓名" prop="userName">
              <el-input
                v-model="searchForm.userName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="微信单号" prop="wxTransactionId">
              <el-input
                v-model="searchForm.wxTransactionId"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="订单号" prop="orderNo">
              <el-input v-model="searchForm.orderNo" clearable placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="联系方式" prop="userPhone">
              <el-input
                v-model="searchForm.userPhone"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="活动状态" prop="statusList">
              <el-select v-model="searchForm.statusList" multiple collapse-tags clearable @change="onSearch">
                <el-option v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="活动名称" prop="activityName">
              <el-input  v-model="searchForm.activityName"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="活动id" prop="activityId">
              <el-input
                v-model="searchForm.activityId"
                clearable
                placeholder="请输入"
                type="number"
              ></el-input>
            </el-form-item>
            <el-form-item label="经销商经营状态" prop="cusStatus">
              <el-select v-model="searchForm.cusStatus" clearable @change="onSearch">
                <el-option v-for="item in businessStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item label="金额筛选" prop="amountType">
              <el-select v-model="searchForm.amountType" clearable @change="onSearch">
                <el-option label="全部" value=""></el-option>
                <el-option label="<9.9" value="1"></el-option>
                <el-option label=">=9.9" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否定制成交" prop="dealStatus">
              <el-select v-model="searchForm.dealStatus" clearable @change="onSearch">
                <el-option label="全部" value=""></el-option>
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="钱包类型" prop="activityType">
              <el-select v-model="searchForm.activityType" clearable @change="onSearch">
                <el-option label="全部" value=""></el-option>
                <el-option label="老钱包" value="1"></el-option>
                <el-option label="新钱包" value="2"></el-option>
                <el-option label="银联钱包" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="exportList(false)">导出</el-button>
          <!-- <el-button type="primary" size="small" @click="exportList(true)">解密导出</el-button> -->
          <el-button type="primary" size="small" @click="exportListStore(1)">所有区域门店数据导出</el-button>
          <el-button type="primary" size="small" @click="exportListStore(2)">区域报名人数导出</el-button>
          <!-- <el-button type="primary" size="small" @click="writeoffSignup">核销报名</el-button> -->
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="joinLogId" label="编号" align="center" width="80" ></el-table-column>
          <el-table-column prop="orderNo" label="订单号" show-overflow-tooltip align="center" min-width="160"></el-table-column>
          <el-table-column prop="wxTransactionId" label="微信单号" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="mchNo" label="银联商户号" show-overflow-tooltip align="center" width="110"></el-table-column>
          <el-table-column prop="joinUserName" label="顾客姓名" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="userPhone" label="联系方式" show-overflow-tooltip min-width="100"></el-table-column>
          <el-table-column prop="createdTime" label="创建订单时间" width="160" align="center"></el-table-column>
          <el-table-column prop="activityId" label="活动id" align="center" width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="activityName" label="活动名称" align="center" show-overflow-tooltip width="160"></el-table-column>
          <el-table-column prop="joinActivityAmount" label="金额(元)" align="center" width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="times" label="报名次数" align="center" width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="sourceTypeExcel" label="来源" align="center" width="60"></el-table-column>
          <el-table-column prop="signupStatusString" label="状态" align="center" width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="dealStatusStr" label="是否定制成交" align="center" width="110" show-overflow-tooltip></el-table-column>
          <el-table-column prop="boolGroupBuyTrans" label="是否团购成交" align="center" width="110" show-overflow-tooltip></el-table-column>
          <el-table-column prop="orgName" label="分享区域" align="center" show-overflow-tooltip width="140"></el-table-column>
          <el-table-column prop="cusName" label="分享经销商" align="center" show-overflow-tooltip width="100"></el-table-column>
          <el-table-column prop="businessStatusExcel" label="经销商经营状态"  width="120" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="storeName"  label="分享门店" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="staffName" label="分享职员/手机号"  align="center" width="130">
            <template v-slot="scope">
              <span style="color: #0BB78E;cursor: pointer;" @click="viewingPersonnel(scope.row, 1)">
                {{ scope.row.staffName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column  prop="verificationStoreName" label="核销门店" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="verificationStaffName" label="核销职员/手机号"  width="130" align="center" >
            <template v-slot="scope">
              <span style="color: #0BB78E;cursor: pointer;" @click="viewingPersonnel(scope.row, 2)">
                {{ scope.row.verificationStaffName }}
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="操作"
            class-name="action-column"
            align="center"
            fixed="right"
            width="120"
          >
            <template v-slot="scope">
              <el-button
                type="text"
                size="small"
                @click="checkPhone(scope.row)"
              >
                查看顾客手机号
              </el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
    <check-phone :isCheckPhone.sync="isCheckPhone" :phone="phone"/>
    <viewing-personnel :visible.sync="isViewingPersonnel" v-if="isViewingPersonnel" :userId="userId" />
    <q-dialog
      :visible="isStorePop"
      title="数据导出"
      width="400px"
      :innerScroll="false"
      :contentLoading="loading"
      @close="close"
      @cancel="close"
      @confirm="onConfirm"
    >
    <div class="center">
      <span>导出时间</span>
      <el-date-picker
        class="date-input"
        size="small"
        v-model="storeDate"
        :default-time="['00:00:00', '23:59:59']"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="daterange"
        range-separator="-"
        start-placeholder="起始时间"
        end-placeholder="截至时间"
        :picker-options="exportType == 1 ? pickerOptionsStore : {}" 
      >
      </el-date-picker>
    </div>
  </q-dialog>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
import checkPhone from './cheack-phone'
import viewingPersonnel from "./viewingPersonnel";
import moment from "moment"
export default {
  name: "newOrderData",
  mixins: [tableMixin,pagePathMixin],
  components: {
    checkPhone,
    viewingPersonnel
  },
  data() {
    return {
      searchForm: {
        orgName:'',
        cusName:'',
        storeName: "",
        staffName: "",
        userName: "",
        userPhone: "",
        statusList: [],
        activityName: "",
        activityId: "",
        startTime: '',
        endTime: "",
        cusStatus: "",
        wxTransactionId: "",
        orderNo: "",
        activityType: "",
        amountType: "",
        dealStatus: ""
      },
      statusOptions: [ 
        {value: 1, label: '待核销'},
        {value: 2, label: '已核销'},
        {value: 3, label: '已退款'},
        {value: 4, label: '待成团'},
        {value: 5, label: '待退款'},
      ],
      businessStatus: [ 
        {value: '', label: '全部'},
        {value: 1, label: '正常营业'},
        {value: 2, label: '预停业'},
        {value: 3, label: '已停业'},
        {value: 4, label: '预营业'},
        {value: 5, label: '未开业停用'},
        {value: 6, label: '经营异常'},
      ],
      panelData: {},

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      actionType: 1,
      isShowAdd: false,
      modifyData: null,
      isCheckPhone: false,
      phone: '',
      pickerOptions:{
        disabledDate: (time) => {
          return new Date(time).getTime() < new Date('2023/1/10').getTime()
        }
      },
      pickerOptionsStore: {
        disabledDate: (time) => {
          return new Date(time).getTime() < new Date('2023/1/1').getTime()
        }
      },
      isStorePop: false,
      storeDate: [],
      isViewingPersonnel: false,
      userId: "1",
      exportType: 1,
    };
  },
  methods: {
    init() {
      this.onSearch();
      this.getOrgBoardInfo();
    },
    getOrgBoardInfo() {
      this.$api.dataReport.orgBoardInfo().then((res) => {
        this.panelData = res.data;
      });
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.dataReport
        .activityOrderList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate()
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null) {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.startTime = ''
      this.searchForm.endTime = ''
      this.$refs.dateRef.reset()
    },
    exportList(type) {
      let params = {
        ...this.filterParam,
        boolDecryptPhone: type
      };
      this.$api.common.doExport("activityOrderList", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
    writeoffSignup() {
      this.openSubPage({path: 'writeoff-signup'})
    },
    checkPhone(row) {
      this.$api.dataReport.decodePhone({phoneRsa:row.phoneRsa})
        .then(res => {
          this.phone = res.data
          this.isCheckPhone = true
        })
    },
    exportListStore(type) {
      this.exportType = type
      this.isStorePop = true
    },
    close() {
      this.isStorePop = false
      this.storeDate = []
    },
    viewingPersonnel(row,type) {
      this.userId = type === 1 ? row.staffUserId : row.verificationStaffUserId
      this.isViewingPersonnel = true
    },
    onConfirm() {
      if (!this.storeDate.length) {
        this.$message.error("请选择导出时间");
        return
      }
      if(this.exportType === 1) {
        let params = {
          startTime: this.storeDate[0],
          endTime: this.storeDate[1]
        };
        this.$api.common.doExport("shopActivityDataPageList", params).then(() => {
          this.$message.success("导出操作成功，请前往导出记录查看详情");
          this.close()
        });

      }else {
        this.customColumnExport()
      }
    },
    generateDateStrings() {
      const startDate = new Date(moment(this.storeDate[0]).format('YYYY-MM-DD'));
      const endDate = new Date(moment(this.storeDate[1]).format('YYYY-MM-DD')); 
      let currentDate = new Date(startDate);
      const dateList = [
        {
          columnName: '区域名称',
          fieldName: 'orgName',
          fieldType: ''
        }
      ];
      while (currentDate <= endDate) {
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, '0'); 
          const day = String(currentDate.getDate()).padStart(2, '0');
          dateList.push(
            {
              columnName: year + '年' + month + '月' + day + '报名人数',
              fieldName: year + '-' + month + '-' + day,
              fieldType: "",
            },
          );
          currentDate.setDate(currentDate.getDate() + 1); 
      }
      return dateList;
    },

    customColumnExport() {
      let columnDTOs  = this.generateDateStrings()
      let params = {
        columnDTOs: columnDTOs,
        taskDTO: {
          appCode: "activity-pc-manage-api",
          reportName: "orgOrderList",
          paramMap: {
            orgName: this.searchForm.orgName,
            startTime: this.storeDate[0],
            endTime: this.storeDate[1]
          },
        },
      };
      this.$api.common.customColumnExport(params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
  },
  filters: {},
  mounted() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.date-input {
  width 220px !important
}
.center {
  height: 10vh;
  text-align: center
  margin-top: 20px;
  span {
    margin-right: 20px;
  }
}

</style>
